import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CollectionsGrid } from './components/CollectionsGrid';
import { BestSellers } from './components/BestSellers';
import { FounderSection } from './components/FounderSection';
import { TrustBar } from './components/TrustBar';
import { FaqSection } from './components/FaqSection';
import { ContactSection } from './components/ContactSection';
import { LiveSaleToast } from './components/LiveSaleToast';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';
interface AppProps {
  showLiveSaleProof?: boolean;
  showWhatsAppButton?: boolean;
}
export function App({
  showLiveSaleProof = true,
  showWhatsAppButton = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-white font-sans text-maroon" data-id="element-0" data-mp="28u5zkrcq1dey">
      <Header data-id="element-1" data-mp="28sbe9bxjfjac" />
      <main data-id="element-2" data-mp="23vci6nubd29i">
        <Hero data-id="element-3" data-mp="23vuokdaowwv5" />
        <CollectionsGrid data-id="element-4" data-mp="23w4clvc6cty7" />
        <BestSellers data-id="element-5" data-mp="23ut9zyugts8o" />
        <FounderSection data-id="element-6" data-mp="23ti8y6semyl9" />
        <FaqSection data-id="element-7" data-mp="3ik7e6ay3c1o0" />
        <ContactSection data-id="element-8" data-mp="3iiwdijzxza14" />
      </main>
      <TrustBar data-id="element-9" data-mp="3ijpef4c7z5bc" />
      <Footer data-id="element-10" data-mp="3ii4q3wgi0ilx" />
      {showLiveSaleProof && <LiveSaleToast data-id="element-11" data-mp="3mkrcviybbdc9" />}
      {showWhatsAppButton && <WhatsAppButton data-id="element-12" data-mp="3mjg7xft4rzjk" />}
    </div>;
}